// 马六甲州球场数据
// Melaka Golf Courses

export const MELAKA_COURSES = {
  "AFAMOSA_GOLF_RESORT_CROCODILE_PALM": {
    shortName: "AGR-CP",
    fullName: "A'Famosa Golf Resort (Crocodile + Palm)",
    location: ["Alor Gajah", "Melaka", "Malaysia"],
    pars: [4,4,4,5,3,4,4,3,5, 4,4,3,5,4,4,3,5,4],
    index: [12,4,18,14,8,10,2,16,6, 3,13,17,1,5,9,15,11,7]
  },

  "AFAMOSA_GOLF_RESORT_Crocodile_Rocky": {
    shortName: "AGR-RC",
    fullName: "A'Famosa Golf Resort (Crocodile + Rocky)",
    location: ["Alor Gajah", "Melaka", "Malaysia"],
    pars: [4,4,4,5,3,4,4,3,5, 4,3,4,5,4,3,5,4,4],
    index: [11,3,17,13,7,9,1,15,5, 2,16,8,6,4,18,10,12,14]
  },

  "AFAMOSA_GOLF_RESORT_ROCKY_PALM": {
    shortName: "AGR-RP",
    fullName: "A'Famosa Golf Resort (Rocky + Palm)",
    location: ["Alor Gajah", "Melaka", "Malaysia"],
    pars: [4,3,4,5,4,3,5,4,4, 4,4,3,5,4,4,3,5,4],
    index: [5,1,7,17,3,13,15,9,11, 10,8,2,14,16,12,18,6,4]
  },

  "AYER_KEROH_COUNTRY_CLUB_GOVERNOR_GHAFFAR": {
    shortName: "AKCC-GG",
    fullName: "Ayer Keroh Country Club (Governor + Ghaffar)",
    location: ["Ayer Keroh", "Melaka", "Malaysia"],
    pars: [4,3,4,4,4,5,5,3,4, 5,3,4,4,4,4,4,3,5],
    index: [15,17,5,9,3,1,13,11,7, 8,18,4,2,6,14,12,16,10]
  },

  "AYER_KEROH_COUNTRY_CLUB_Governor_Tunku": {
    shortName: "AKCC-TG",
    fullName: "Ayer Keroh Country Club (Governor + Tunku)",
    location: ["Ayer Keroh", "Melaka", "Malaysia"],
    pars: [4,3,4,4,4,5,5,3,4, 4,4,4,3,4,5,3,4,5],
    index: [15,17,5,9,3,1,13,11,7, 18,6,4,12,8,10,16,14,2]
  },

  "AYER_KEROH_COUNTRY_CLUB_TUNKU_Ghaffar": {
    shortName: "AKCC-Tunku + Ghaffar",
    fullName: "Ayer Keroh Country Club (Tunku + Ghaffar)",
    location: ["Ayer Keroh", "Melaka", "Malaysia"],
    pars: [4,4,4,3,4,5,3,4,5, 5,3,4,4,4,4,4,3,5],
    index: [17,5,3,11,7,9,15,13,1, 8,18,4,2,6,14,12,16,10]
  },

  "ORNA_GOLF_AND_COUNTRY_CLUB_EAST_NORTH": {
    shortName: "OGCC-EN",
    fullName: "Orna Golf & Country Club (East + North)",
    location: ["Bemban", "Melaka", "Malaysia"],
    pars: [4,3,4,5,4,4,5,3,4, 4,3,5,3,4,4,4,5,4],
    index: [15,17,1,13,7,9,3,11,5, 6,10,4,14,18,12,8,2,16]
  },

  "ORNA_GOLF_AND_COUNTRY_CLUB_EAST_WEST": {
    shortName: "OGCC-EW",
    fullName: "Orna Golf & Country Club (East + West)",
    location: ["Bemban", "Melaka", "Malaysia"],
    pars: [4,3,4,5,4,4,5,3,4, 4,5,3,4,4,4,5,3,4],
    index: [15,17,1,13,7,9,3,11,5, 16,14,8,12,2,10,4,18,6]
  },

  "ORNA_GOLF_AND_COUNTRY_CLUB_WEST_NORTH": {
    shortName: "OGCC-WN",
    fullName: "Orna Golf & Country Club (West + North)",
    location: ["Bemban", "Melaka", "Malaysia"],
    pars: [4,5,3,4,4,4,5,3,4, 4,3,5,3,4,4,4,5,4],
    index: [16,14,8,12,2,10,4,18,6, 5,9,3,13,17,11,7,1,15]
  },

  "TIARA_MELAKA_GOLF_AND_COUNTRY_CLUB_LAKE_MEADOW": {
    shortName: "TMGCC-LM",
    fullName: "Tiara Melaka Golf & Country Club (Lake + Meadow)",
    location: ["Melaka", "Melaka", "Malaysia"],
    pars: [4,4,3,5,4,4,3,4,5, 4,5,4,3,4,3,5,4,4],
    index: [18,4,12,8,14,16,10,2,6, 17,7,9,13,5,15,3,1,11]
  },

  "TIARA_MELAKA_GOLF_AND_COUNTRY_CLUB_LAKE_WOODLAND": {
    shortName: "TMGCC-LW",
    fullName: "Tiara Melaka Golf & Country Club (Lake + Woodland)",
    location: ["Melaka", "Melaka", "Malaysia"],
    pars: [4,4,3,5,4,4,3,4,5, 4,3,4,5,4,4,5,3,4],
    index: [18,4,12,8,14,16,10,2,6, 17,13,5,1,15,3,7,9,11]
  },

  "TIARA_MELAKA_GOLF_AND_COUNTRY_CLUB_MEADOW_WOODLAND": {
    shortName: "TMGCC-MW",
    fullName: "Tiara Melaka Golf & Country Club (Meadow + Woodland)",
    location: ["Melaka", "Melaka", "Malaysia"],
    pars: [4,5,4,3,4,3,5,4,4, 4,3,4,5,4,4,5,3,4],
    index: [17,7,9,13,5,15,3,1,11, 18,14,6,2,16,4,8,10,12]
  }
};

export default MELAKA_COURSES;
